import {
  fetch_case_verification_checks,
  run_case_verification_check,
} from '@/services/xverdict_verification_service';
import { error_message } from './view_case_details_helpers';

function check_key(check = {}) {
  return String(check?.id || check?.service_id || '');
}

function runnable_checks(checks = []) {
  return (Array.isArray(checks) ? checks : []).filter((check) => check?.runnable);
}

function verification_context(component) {
  return {
    entity_type_id: component.selected_entity_type_id,
    entity_profile_id: component.selected_entity_profile_id,
    project_id: component.project_id,
    forms: component.backend_application_forms,
  };
}

function failed_run_message(result, check) {
  return error_message(result?.reason, `Unable to run ${check?.name || 'verification'}.`);
}

export default {
  async load_case_verifications() {
    this.loading_verification_checks = true;
    this.verification_error = '';

    try {
      this.verification_checks = await fetch_case_verification_checks(verification_context(this));
    } catch (error) {
      this.verification_checks = [];
      this.verification_error = error_message(error, 'Failed to load the configured verification checks.');
    } finally {
      this.loading_verification_checks = false;
    }
  },
  verification_check_is_running(check = {}) {
    return this.running_verification_keys.includes(check_key(check));
  },
  async run_case_verification(check = null) {
    const checks = check ? [check] : runnable_checks(this.verification_checks);
    if (!checks.length) {
      this.verification_error = 'No configured verification check is mapped to a submitted case form.';
      return;
    }

    this.verification_error = '';
    const keys = checks.map(check_key);
    this.running_verification_keys = [...new Set([...this.running_verification_keys, ...keys])];

    const results = await Promise.allSettled(checks.map(run_case_verification_check));
    const failures = results
      .map((result, index) => result.status === 'rejected' ? failed_run_message(result, checks[index]) : '')
      .filter(Boolean);

    this.running_verification_keys = this.running_verification_keys.filter((key) => !keys.includes(key));
    await this.load_case_verifications();
    if (failures.length) {
      this.verification_error = failures.join(' ');
    }
  },
};
